module.exports = {"230206001":"红岸街道","230206003":"沿江街道","230206004":"电力街道","230206005":"幸福街道","230206006":"红宝石街道","230206007":"北兴街道","230206008":"铁北街道","230206009":"和平街道","230206200":"长青乡","230206202":"杜尔门沁达斡尔族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230206.json
// module id = 694
// module chunks = 0